






























import Vue from "vue";
import PlayerAndTeamSelectionView from "@/components/PlayerAndTeamsSelector/components/PlayerAndTeamSelectionView.vue";
import router from "@/router";
import { mapGetters, mapMutations } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { UserOrganizationsAndTeams } from "@/types";
import { bus } from "@/main";
import MutationTypes from "@/store/MutationTypes";
import { Routes } from "@/router/Routes";

interface State {
  showModal: boolean;
  selectedOrg: UserOrganizationsAndTeams | null | undefined;
  selectedTeam: UserOrganizationsAndTeams | null | undefined;
  selectedPlayers: string | null;
}

export default Vue.extend({
  name: "PlayersAndTeamsSelector",
  components: { PlayerAndTeamSelectionView },
  props: {
    selectionRequired: {
      type: Boolean,
      default: false
    }
  },
  data(): State {
    return {
      showModal: false,
      selectedTeam: null,
      selectedOrg: null,
      selectedPlayers: null
    };
  },
  methods: {
    select({ orgId, teamId }: { orgId: string; teamId: string }) {
      try {
        this.setSelections({ orgId, teamId });

        this.$emit("select", { orgId, teamId });
      } catch (e) {
        bus.$emit("errorSnack", e.message);
        this.showModal = true;
        return;
      }

      if (!orgId && !teamId) {
        router
          .push({
            name: Routes.FAN_PLAYERS.name
          })
          .catch(console.error);
        this.showModal = false;
        return;
      }

      //If switching from player view to coach view, reset to the 'dashboard'
      //if switching between any coach views, preserve the current view.

      // Determining if the user is switching between coach and fan views, or just switching between teams.
      // orgId is null when the user is switching to the fan view, but always present in team or org views
      const contextChanging =
        (this.$route.params.orgId && !this.selectedOrg?.id) ||
        (!this.$route.params.orgId && this.selectedOrg?.id);

      // If the user is switching between coach and fan views, we need to redirect them to the dashboard for coach view or fan view
      if (contextChanging) {
        //building the path to redirect to. Could be /teams /teams/:orgId or /teams/:orgId/:teamId
        let path = "";
        if (this.selectedOrg?.id) {
          path = `${this.selectedOrg?.id ? `/${this.selectedOrg?.id}` : ""}${
            this.selectedOrg?.id && this.selectedTeam?.id
              ? `/${this.selectedTeam.id}`
              : ""
          }/teams`;
        } else {
          path = `/players`;
        }
        router
          .push({
            path: path
          })
          .catch(console.error);
      } else {
        // If the user is just switching between teams, we can just update the route params
        // and the components will update automatically

        router
          .push({
            params: {
              orgId,
              teamId
            }
          })
          .catch(console.error);
      }
      this.showModal = false;
    },
    setSelections({ orgId, teamId }: { orgId: string; teamId: string }) {
      let org;
      let team;

      if (orgId) {
        org = this.playersAndTeams.organizations.find(
          (o: UserOrganizationsAndTeams) => o.id === orgId
        );
        if (org) {
          team = org.teams.find(
            (t: UserOrganizationsAndTeams) => t.id === teamId
          );
        }
      }

      if ((orgId && !org) || (orgId && org && teamId && !team)) {
        //if the user is trying to access a team or org they don't have access to, clear the route and throw error
        // router.push({ path: "/teams" }).catch(console.error);
        throw new Error("Unauthorized to access this team or organization");
      } else {
        this.selectedOrg = org;
        this.selectedTeam = team;
      }

      //These need to be set every update, not just when present, so they get reset
      this.selectedOrg = org;
      this.selectedTeam = team;
      this.selectedPlayers =
        this.selectedOrg ||
        (this.playersAndTeams.players.length === 0 &&
          this.playersAndTeams.following.length === 0)
          ? null
          : "active";

      this.setOrgUnitSelection({
        org: this.selectedOrg,
        team: this.selectedTeam
      });
      this.showModal = false;
    },
    ...mapMutations({
      setOrgUnitSelection: MutationTypes.SET_ORG_UNIT_SELECTION
    })
  },
  computed: {
    modalActive(): boolean {
      const active =
        this.showModal ||
        (!this.selectedOrg &&
          !this.selectedTeam &&
          !this.selectedPlayers &&
          this.selectionRequired);

      this.$emit("selectorActive", active);

      return active;
    },
    mainTitle(): string {
      if (this.selectedPlayers) {
        return "My Players";
      }
      if (this.selectedTeam) {
        return this.selectedTeam.name;
      }
      if (this.selectedOrg) {
        return this.selectedOrg.name;
      }
      return "SELECT A TEAM";
    },
    ...mapGetters({
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS
    })
  },
  watch: {
    playersAndTeams: {
      handler(newVal) {
        this.setSelections({
          orgId: this.$route.params.orgId,
          teamId: this.$route.params.teamId
        });
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function() {
        this.setSelections({
          orgId: this.$route.params.orgId,
          teamId: this.$route.params.teamId
        });
      },
      immediate: true
    }
  }
});
